import { useMemo } from 'react';
import FilterDropdown from 'components/elements/Dropdown/FilterDropdown';
import { useEventTriggerDocTypeByStateCode } from 'state/eventTriggers';
import { useDocTypeFilter, useStateDocFilter } from 'state/filterDocuments';

const DocumentTypeFilter = () => {
  const { stateFilter } = useStateDocFilter();
  const cityDocumentTypes = useEventTriggerDocTypeByStateCode(stateFilter || null);
  const { docTypeFilter, setDocTypeFilter } = useDocTypeFilter();

  const options = useMemo(
    () =>
      cityDocumentTypes.map(({ code, name }) => ({
        value: String(code),
        label: name,
      })),
    [cityDocumentTypes],
  );

  return (
    <FilterDropdown
      options={options}
      checkedValues={docTypeFilter}
      setCheckedValues={setDocTypeFilter}
      onClearAll={() => setDocTypeFilter([])}
      maxHeight="280px"
      isFilterEnabled
      sortSelectedFirst
    >
      Document Type
    </FilterDropdown>
  );
};

export default DocumentTypeFilter;
